import { BolttechCryptoServiceInterface } from '../bolttech-crypto';
import {
  KeyLike,
  privateDecrypt,
  publicEncrypt,
  RsaPrivateKey,
  RsaPublicKey,
} from 'crypto';

export class BolttechCryptoService implements BolttechCryptoServiceInterface {
  encryptStringWithRsaPublicKey(
    toEncrypt: unknown,
    publicKey: RsaPublicKey | KeyLike,
  ): string {
    const buffer = Buffer.from(JSON.stringify(toEncrypt));
    const encrypted = publicEncrypt(publicKey, buffer);
    return encrypted.toString('base64');
  }

  decryptStringWithRsaPrivateKey(
    toDecrypt: string,
    privateKey: RsaPrivateKey | KeyLike,
  ): string {
    const buffer = Buffer.from(toDecrypt, 'base64');
    const decrypted = privateDecrypt(privateKey, buffer);
    return decrypted.toString('utf8');
  }
}

export const bolttechCryptoService = new BolttechCryptoService();
